<template>
	<div>
		<el-form :model="employ" :rules="rules" style="text-align:left" label-position="right" label-width="180px" ref="employ"  size="small" >
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="发布信息" prop="title">
							<el-input v-model="employ.title"></el-input>
						</el-form-item>
						<el-col :span="12">
						<el-form-item label="信息类型" prop="type">
  							<el-radio v-model="employ.type" label="1">招聘</el-radio>
  							<el-radio v-model="employ.type" label="2">租赁</el-radio>
						</el-form-item>
					</el-col>
					</el-col>
				</el-row>
			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="backToLisk">返回</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
	</div>
</template>
<script>
	import {getEmploy,addEmploy} from '@/api/api.js'
	import tools from "@/tools"
	import Editor from 'wangeditor'
	import 'wangeditor/release/wangEditor.min.css'
	export default {
		components:{
			Editor
		},
		data(){
			return {
				employ:{
					id:'',
					title:"",
					desc:"",
					type:""
				},
				rules: {
		          title: [
		            { required: true, message: '请输入发布信息', trigger: 'blur' }
		          ],
		          type: [
		            { required: true, message: '请选择信息类型', trigger: 'blur' }
		          ]
		      	},
				addLoading:false
			}

		},
		
		created:function() {
			var id = this.$route.query.id;
			
			if(id){
				getEmploy({id:id}).then(res=>{
					this.employ = res.data.data;
				})
			};
			
		},
		methods:{
			addSubmit(){
				
				this.$refs["employ"].validate((valid)=>{
					this.addLoading=true;
					if(valid){
						addEmploy(this.employ).then(res=>{
							if(res.data.status=="success"){
								this.$message('添加成功');
								this.addLoading=false;
								this.$router.go(-1);
							}
						});	
					};
					this.addLoading=false;	
				});
			},
		    backToLisk(){
		    	this.$router.go(-1);
		    }
		}
	}
</script>